export const setCursorToTheEnd = (ref: HTMLDivElement) => {
  const element = ref;
  if (!element) return;
  element.focus();
  const range = document.createRange();
  range.selectNodeContents(element);
  range.collapse(false); // схлопываем в конец
  const selection = window.getSelection();
  selection?.removeAllRanges();
  selection?.addRange(range);
}
